<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="2" sm="4" md3>
          <v-dialog ref="dialog" v-model="modal2" :return-value.sync="dateRange" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                solo
                dense
                v-model="fromToRange"
                :rules="[requiredValidator('date range')]"
                label="Date Range"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-if="modal2" v-model="dateRange" range full-width :min="lastReportGenDate">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal2 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(dateRange)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="3" sm="4" md4>
          <v-menu
            ref="menu"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="deliveryDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                solo
                dense
                :rules="[requiredValidator('delivery date')]"
                v-model="deliveryDate"
                label="Delivery Date"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-if="menu2" v-model="deliveryDate" full-width :min="minDeliveryDate" :max="maxDeliveryDate">
              <v-btn text color="primary" @click="menu2 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(deliveryDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3" md4 sm="4">
          <v-btn color="primary" :disabled="!valid" :width="$vuetify.breakpoint.smAndUp ? 150 : 100" class="text-capitalize light--text font-weight-bold" :loading="btnloading" @click="assignToDriver"
            >Assign To Driver</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
    <span v-if="noOfDaysToGenerate">No of days selected: {{ noOfDaysToGenerate }}</span>
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:[`item.fromDate`]="{ item }"> {{ dateFormat(item.fromDate) }}</template>
      <template v-slot:[`item.toDate`]="{ item }"> {{ dateFormat(item.toDate) }}</template>
      <template v-slot:[`item.deliveryDate`]="{ item }"> {{ dateFormat(new Date(parseInt(item.deliveryDate))) }}</template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <router-link
            :to="{
              name: 'SetMenuReportMaster',
              params: { reportId: item._id },
              query: { reportId: item._id },
            }"
            class="mx-auto"
          >
            DETAILS
          </router-link>
          <router-link
            :to="{
              name: 'SetMenuCustomerList',
              params: { reportId: item._id },
              query: { reportId: item._id },
            }"
            class="mx-auto"
          >
            CUSTOMERS
          </router-link>
          <router-link
            :to="{
              name: 'SetMenuMeals',
              params: { reportId: item._id },
              query: { reportId: item._id },
            }"
            class="mx-auto"
          >
            MEALS
          </router-link>
          <RemoveReport :report="item" v-if="item.serialNumber == 1" />
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
import { requiredValidator } from "../../core/methods/validations";
import RemoveReport from "../components/RemoveReport.vue";
export default {
  components: { RemoveReport },

  mounted() {
    this.$root.$on("updateSetmenuList", () => {
      this.$apollo.queries.getSetMenuReports.refetch({});
    });
  },
  apollo: {
    getSetMenuReports() {
      return {
        query: require("../api/getSetMenuReports.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.setMenuReports = data.getSetMenuReports.setMenuReports;

          this.setMenuReports = this.setMenuReports.map((item, index) => ({
            ...item,
            serialNumber: (this.options.page - 1) * this.options.itemsPerPage + index + 1,
          }));
        },
      };
    },
    getSetmenuLastReportGeneratedDate() {
      return {
        query: require("../api/getSetmenuLastReportGeneratedDate.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          let date = data.getSetmenuLastReportGeneratedDate;
          this.lastReportGenDate = moment(date)
            .add(1, "days")
            .format("YYYY-MM-DD");
        },
      };
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    assignToDriver() {
      this.btnloading = true;
      let startDate = this.dateRange[0];
      let endDate = this.dateRange[1] ? this.dateRange[1] : this.dateRange[0];
      let momentStartDate = moment(startDate);
      let momentEndDate = moment(endDate);

      let fromDate;
      let toDate;
      if (momentStartDate < momentEndDate) {
        fromDate = startDate;
        toDate = endDate;
      } else {
        fromDate = endDate;
        toDate = startDate;
      }
      this.$apollo
        .mutate({
          mutation: require("../api/generateSetMenuReports.graphql"),
          variables: {
            fromDate: fromDate,
            toDate: toDate,
            deliveryDate: this.deliveryDate,
          },
        })
        .then(() => {
          this.text = "Configuration updated";
          this.snackbar = true;
          this.btnloading = false;
          this.snackbarColor = "success";
          this.dialog = false;
        })
        .catch(error => {
          this.btnloading = false;
          console.log(error);
        });
    },
  },
  watch: {
    dateRange: {
      handler(val) {
        this.fromToRange = val.join(" - ");
        let startDate = val[0];
        let endDate = val[1];
        let momentStartDate = moment(startDate);
        let momentEndDate = moment(endDate);
        if (val[0] && val[1]) {
          if (momentStartDate < momentEndDate) {
            this.fromToRange = `${val[0]} - ${val[1]}`;
          } else {
            this.fromToRange = `${val[1]} - ${val[0]}`;
          }
        }
        let diff = momentEndDate.diff(momentStartDate, "days");
        this.noOfDaysToGenerate = diff > 0 ? diff : "";
        this.maxDeliveryDate = momentStartDate.format("YYYY-MM-DD");
      },
    },
  },
  data: () => ({
    requiredValidator,
    variables: {
      limit: 50,
      skip: 0,
    },
    options: {
      itemsPerPage: 50,
      page: 1,
    },
    loading: true,
    dateRange: null,
    modal2: false,
    valid: false,
    menu2: false,
    fromToRange: "",
    noOfDaysToGenerate: "",
    deliveryDate: null,
    btnloading: false,
    lastReportGenDate: null,
    setMenuReports: [],
    minDeliveryDate: moment().format("YYYY-MM-DD"),
    maxDeliveryDate: moment().format("YYYY-MM-DD"),
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 60,
      },
      { text: "From", value: "fromDate", width: 120, sortable: false },
      {
        text: "To",
        value: "toDate",
        width: 120,
        sortable: false,
      },

      {
        text: "Assigned Date",
        value: "deliveryDate",
        sortable: false,
        width: 120,
      },

      {
        text: "Assigned By",
        value: "createdBy.firstnameEn",
        sortable: false,
        width: 120,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: 220,
      },
    ],
  }),
  computed: {
    itemsWithSno() {
      if (this.setMenuReports == null) return [];
      return this.setMenuReports.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  created() {
    setInterval(() => {
      this.$apollo.queries.getSetMenuReports.refetch({});
    }, 5000);
  },
};
</script>
